import { DownloadButton } from '@/containers/DownloadButton'
import { useGetProductSheets } from '@/hooks/useProductSheets'
import { useInsuranceParamsContext } from '@/layouts/Wizard'
import { Button, Modal, ModalBody, ModalContent, ModalFooter, ModalHeader, ModalOverlay, Stack } from '@chakra-ui/react'
import type { Offer } from 'BrokerTsLib/src/dtos'
import type { Insurer } from 'BrokerTsLib/src/enums'

export const OfferDocumentsModal = ({ isOpen, onClose, offer }: {
    isOpen: boolean
    onClose: () => void
    offer: Offer
}) => {
    const { insuranceParamsId } = useInsuranceParamsContext()
    const productSheets = useGetProductSheets(offer.insurerId as Insurer)

    return (
        <Modal isOpen={isOpen} onClose={onClose} size="lg" isCentered>
            <ModalOverlay />

            <ModalContent>
                <ModalHeader my={2}>Dokumenty k pojištění pro nabídku #{offer.offerId}/{insuranceParamsId}</ModalHeader>
                
                <ModalBody>
                    <Stack alignItems='start' gap={2}>
                        {productSheets?.map((sheet) => (<DownloadButton key={sheet.label} as={'a'} target='_blank' href={sheet.url}>{sheet.label}</DownloadButton>))}
                    </Stack>
                </ModalBody>
                <ModalFooter>
                    <Button onClick={onClose} colorScheme='primary'>Zavřít</Button>
                </ModalFooter>
            </ModalContent>
        </Modal>
    )
}